<div class="financial-health-chart" [ngClass]="{'financial-health-chart--force-desktop': forceDesktopStyle}">
  <div class="chart__left">
    <div class="pie-chart">
      <div class="pie-chart__retirement">
        <img
          mfpLazyImage
          lazySrc="assets/icons/protection-card-RETIREMENT.svg"
        />
        <p class="pie-chart__number">30%</p>
      </div>

      <div class="pie-chart__financial">
        <h2 class="pie-chart__text">
          {{ financialSituationTitle }}
        </h2>
        <p class="pie-chart__number">20%</p>
      </div>

      <div class="pie-chart__savings">
        <img
          mfpLazyImage
          lazySrc="assets/icons/protection-card-SAVING.svg"
        />
        <p class="pie-chart__number">10%</p>
      </div>

      <div class="pie-chart__education">
        <img
          mfpLazyImage
          lazySrc="assets/icons/protection-card-EDUCATION.svg"
        />
        <p class="pie-chart__number">10%</p>
      </div>

      <div class="pie-chart__death">
        <img
          mfpLazyImage
          lazySrc="assets/icons/protection-card-DEATH.svg"
        />
        <p class="pie-chart__number">30%</p>
      </div>

      <img
        mfpLazyImage
        lazySrc="assets/images/circle.svg"
      />
    </div>
  </div>

  <div class="chart__legend">
    <div class="chart__legend-row">
      <img
        mfpLazyImage
        class="chart__legend-icon-large"
        lazySrc="assets/icons/protection-card-DEATH.svg"
      />
      <p class="chart__legend-text">{{ deathTitle }}</p>
    </div>

    <div class="chart__legend-row">
      <img
        mfpLazyImage
        class="chart__legend-icon"
        lazySrc="assets/icons/protection-card-EDUCATION.svg"
      />
      <p class="chart__legend-text">{{ educationTitle }}</p>
    </div>

    <div class="chart__legend-row">
      <img
        mfpLazyImage
        class="chart__legend-icon"
        lazySrc="assets/icons/protection-card-SAVING.svg"
      />
      <p class="chart__legend-text">{{ savingTitle }}</p>
    </div>

    <div class="chart__legend-row">
      <img
        mfpLazyImage
        class="chart__legend-icon"
        lazySrc="assets/icons/protection-card-RETIREMENT.svg"
      />
      <p class="chart__legend-text">{{ retirementTitle }}</p>
    </div>
  </div>
</div>
